import { defineMessages } from 'react-intl';

const messages = defineMessages({
  followingTitle: {
    defaultMessage: 'New designs from people you follow',
    description: 'Heading for the following feed.'
  }
});

export default messages;
